import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import {TenantAdministratorContext} from "./TenantAdministratorProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import countries from "../../../../functions/getCountries";
import "../../../../styles/workspace_styles/SystemAdministratorStyles/TenantAdministrators/EditTenantAdministrator.css";

const EditTenantAdministrator = () => {
    const {user,logout} = useContext(AppContext);
    const{
        setReloadTenantAdministrators,
        selectedToEditTenantAdministrator,setSelectedToEditTenantAdministrator
    } = useContext(TenantAdministratorContext);
    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [emailAddress,setEmailAddress] = useState('');
    const [selectedCountry,setSelectedCountry] = useState('');
    const [city,setCity] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [postalCode,setPostalCode] = useState('');
    const [address,setAddress] = useState('');
    const [address2,setAddress2] = useState('');

    const [showCountriesBrowser,setShowCountriesBrowser] = useState(false);
    const [countryFilterString,setCountryFilterString] = useState('');
    const [updateTenantAdministratorStatus,setUpdateTenantAdministratorStatus] = useState('');
    const updateTenantAdministrator = async () =>{
        const updateTenantAdministratorPayload = {
            firstName: firstName,
            lastName: lastName,
            emailAddress: emailAddress,
            country: selectedCountry,
            city: city,
            phoneNumber: phoneNumber,
            postalCode: postalCode,
            address: address,
            address2: address2
        };
        const url = `${usersMicroserviceUrl}/system-admins/tenants/${selectedToEditTenantAdministrator?.id}`;
        try{
            const response = await fetch(url,{
                method: 'PATCH',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body: JSON.stringify(updateTenantAdministratorPayload)
            });
            if(response.ok){
                setUpdateTenantAdministratorStatus('updated');
                setReloadTenantAdministrators(true);
                return;
            }
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error(`An error occurred when updating tenant administrator with id ${selectedToEditTenantAdministrator?.id}`,error);
        }
        setUpdateTenantAdministratorStatus('update-error');
    };
    const loadTenantAdministrator = () =>{
        setFirstName(selectedToEditTenantAdministrator?.firstName || '');
        setLastName(selectedToEditTenantAdministrator?.lastName || '');
        setEmailAddress(selectedToEditTenantAdministrator?.emailAddress || '');
        setSelectedCountry(selectedToEditTenantAdministrator?.country || '');
        setCity(selectedToEditTenantAdministrator?.city || '');
        setPhoneNumber(selectedToEditTenantAdministrator?.phoneNumber || '');
        setPostalCode(selectedToEditTenantAdministrator?.postalCode || '');
        setAddress(selectedToEditTenantAdministrator?.address || '');
        setAddress2(selectedToEditTenantAdministrator?.address2 || '');
    };
    const clearEditTenantAdministratorEntries = () =>{
        setCountryFilterString('');
        setShowCountriesBrowser(false);
        setFirstName('');
        setLastName('');
        setEmailAddress('');
        setSelectedCountry('');
        setCity('');
        setPhoneNumber('');
        setPostalCode('');
        setAddress('');
        setAddress2('');
        setUpdateTenantAdministratorStatus('');
    };
    const validFormToolTipText = () =>{
        if(firstName === '') return 'Enter the first name to proceed';
        if(lastName === '') return 'Enter the last name to proceed';
        if(emailAddress === '') return 'Enter a valid email address to proceed';
        if(selectedCountry === null) return "Select the user's country to proceed";
        if(city === '') return 'Enter city name to proceed';
        return '';
    };
    const disposeWindow = () =>{
        clearEditTenantAdministratorEntries();
        setSelectedToEditTenantAdministrator(null);
    };
    useEffect(() => {
        const handleEsc = (e) =>{
            if(e.key === 'Escape' && (updateTenantAdministratorStatus === 'updated' || updateTenantAdministratorStatus === 'update-error')) disposeWindow();
        };
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    },[selectedToEditTenantAdministrator,updateTenantAdministratorStatus]);
    useEffect(() =>{
        loadTenantAdministrator();
    },[selectedToEditTenantAdministrator]);
    if(!selectedToEditTenantAdministrator) return null;
    return(
        <div className="system-administrator-edit-tenant-administrator-parent-container">
            {updateTenantAdministratorStatus === ''?
                (
                    <div className="system-administrator-edit-tenant-administrator-container">
                        <div className="system-administrator-edit-tenant-administrator-header">
                            <h1>Edit tenant administrator</h1>
                            <p onClick={() => disposeWindow()}>&#10006;</p>
                        </div>
                        <div className="system-administrator-edit-tenant-administrator-body">
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>First Name<span>*</span></p>
                                <input
                                    placeholder="Enter first name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Last Name<span>*</span></p>
                                <input
                                    placeholder="Enter last name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Email Address<span>*</span></p>
                                <input
                                    placeholder="Enter email address"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Country<span>*</span></p>
                                {selectedCountry?
                                    (
                                        <div className="system-administrator-edit-tenant-administrator-selected-country-display">
                                            <p>{selectedCountry}</p>
                                            <p className="cancel-p" onClick={() => setSelectedCountry(null)}>&#10006;</p>
                                        </div>
                                    ):
                                    (
                                        <input
                                            placeholder="Select country"
                                            value={countryFilterString}
                                            onChange={(e) => setCountryFilterString(e.target.value)}
                                            onFocus={() => setShowCountriesBrowser(true)}
                                            onBlur={() => setTimeout(() =>{setShowCountriesBrowser(false)},150)}
                                        />
                                    )
                                }
                                <div className={`system-administrator-edit-tenant-administrator-countries-browser ${showCountriesBrowser? 'active': ''}`}>
                                    {[...countries].filter(country => country.toLowerCase().includes(countryFilterString.toLowerCase())).
                                    sort((a,b) => a.localeCompare(b)).map((country)=>(
                                        <div key={country} onClick={() =>{
                                            setSelectedCountry(country);
                                            setCountryFilterString('');
                                        }}>{country}</div>
                                    ))}
                                </div>
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>City<span>*</span></p>
                                <input
                                    placeholder="Enter city"
                                    value={city}
                                    onChange={(e)=>setCity(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Phone Number</p>
                                <input
                                    placeholder="Enter phone number"
                                    value={phoneNumber}
                                    onChange={(e)=>setPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Postal Code</p>
                                <input
                                    placeholder="Enter postal code"
                                    value={postalCode}
                                    onChange={(e)=>setPostalCode(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Address</p>
                                <input
                                    placeholder="Enter address"
                                    value={address}
                                    onChange={(e)=>setAddress(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-edit-tenant-administrator-entry-container">
                                <p>Address 2</p>
                                <input
                                    placeholder="Enter address 2"
                                    value={address2}
                                    onChange={(e)=>setAddress2(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="system-administrator-edit-tenant-administrator-buttons-container">
                            <button className="cancel" onClick={() => disposeWindow()}>Cancel</button>
                            <button
                                className={`update ${validFormToolTipText() === ''? 'active': 'inactive'}`}
                                title={validFormToolTipText()}
                                onClick={() =>{
                                    if(validFormToolTipText() !== '') return;
                                    updateTenantAdministrator();
                                }}
                            >Update</button>
                        </div>
                    </div>
                ):updateTenantAdministratorStatus === 'updating'?
                (
                    <div className="system-administrator-edit-tenant-administrator-updating-container">
                        <div></div>
                        <p>Updating tenant administrator. Please wait...</p>
                    </div>
                ):updateTenantAdministratorStatus === 'updated'?
                (
                    <div className="system-administrator-edit-tenant-administrator-updated-container">
                        <div className="system-administrator-edit-tenant-administrator-updated-details-container">
                            <p>Tenant administrator updated successfully</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="system-administrator-edit-tenant-administrator-updated-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):updateTenantAdministratorStatus === 'update-error'?
                (
                    <div className="system-administrator-edit-tenant-administrator-update-error-container">
                        <div className="system-administrator-edit-tenant-administrator-update-error-details-container">
                            <p>Unexpected error occurred when updating tenant administrator</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="system-administrator-edit-tenant-administrator-update-error-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <></>
                )
            }
        </div>
    );
};
export default EditTenantAdministrator;